import React, { Fragment, useContext, useEffect, useState } from "react";
import "./quoteDetails.scss";
import {
  DeliveryIconEstimate,
  PickupIconEstimate,
} from "../../../common/CustomIcon";
import {
  alignRight,
  borderCollapseInherit,
} from "../../../helpers/invoice_styles";
import { getFormattedWeight } from "../../../helpers/common";
import AppConfig from "../../../config/AppConfig";
import moment from "moment";
import { TableImageColumn } from "../../../common/TableImageColumn";
import { UserContext } from "../../../context/UserContext";
import DisplayTime from "../../../components/common/DisplayTime";
import { setAppointmentDetails } from "../../../helpers/quotes";
import I18n from "../../../common/I18n";
import { OrgContext } from "../../../context/OrgContext";

function QuoteOrderDetails({
  quote,
  wh_location_details,
  orders,
  order_items,
  pickup_location_details = null,
  delivery_location_details = null,
  appointment,
  quoteCharges,
  logo,
  decimalPoints,
  zeroValue,
}) {

  const addOnDetailsLength = quote?.quotes.length;
  const addonDetails = quote?.quotes[addOnDetailsLength - 1];
  const { orgRules } = useContext(UserContext);
  const { orgSettings: organizationSettings } = useContext(OrgContext);

  const [isMilitaryTime, SetIsMilitary] = useState(
    organizationSettings.is_military_time === "true"
  );

  const pickTime = setAppointmentDetails(
    appointment,
    "R",
    pickup_location_details?.time_zone_id || ""
  );
  const dropTime = setAppointmentDetails(
    appointment,
    "D",
    delivery_location_details?.time_zone_id || ""
  );

  useEffect(() => {
    SetIsMilitary(organizationSettings.is_military_time === "true");
  }, [organizationSettings]);

  const renderPickDropDate = () => {
    const pickTime = setAppointmentDetails(
      appointment,
      "R",
      pickup_location_details?.time_zone_id
    );
    const dropTime = setAppointmentDetails(
      appointment,
      "D",
      delivery_location_details?.time_zone_id
    );

    return (
      <>
        <div className="pick-delivery-card">
          <div>
            <div className="pick">
              <PickupIconEstimate />
              &nbsp; Pickup Address :{" "}
              {pickup_location_details?.l_address.address_line1 || "NA"},{" "}
              {pickup_location_details?.l_address.city}
            </div>
            <div className="flex">
              <p>Date :</p>
              <p style={{ color: "black" }}>
                &nbsp;
                {(!(quote?.type_of_order === "D") &&
                  renderPickupDropTime("Pickup", pickTime)) ||
                  " NA"}
              </p>
              <p style={{ paddingLeft: "40px" }}>{I18n.t("general.short_los")}:</p>
              <p style={{ color: "black", paddingLeft: "10px" }}>
                {pickup_location_details?.los_name || "NA"}
              </p>
            </div>
          </div>
          <div>
            <div className="pick">
              <DeliveryIconEstimate />
              &nbsp; Delivery Address :{" "}
              {delivery_location_details?.l_address.address_line1 ||
                " NA"}, {delivery_location_details?.l_address.city}
            </div>
            <div className="flex gap-2">
              <p>Date :</p>
              <p style={{ color: "black" }}>
                &nbsp;
                {(!(quote?.type_of_order === "R") &&
                  renderPickupDropTime("Drop", dropTime)) ||
                  " NA"}
              </p>
              <p style={{ paddingLeft: "40px" }}>{I18n.t("general.short_los")}: </p>
              <p style={{ color: "black", paddingLeft: "10px" }}>
                {" "}
                {delivery_location_details?.los_name || " NA"}
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderPickupDropTime = (type, data) => {
    return (
      <>
        {!_.isEmpty(data) && data.item_option ? (
          <span className="">
            {/* {moment.utc(quote.expiry_date).format(AppConfig.dateFormat)} */}
            {data.item_option.includes("ANY") ? (
              <Fragment>
                {moment.utc(data.item_preference).format(AppConfig.dateFormat)}{" "}
                {isMilitaryTime
                  ? I18n.t("appointmentForm.military_any_time")
                  : I18n.t("appointmentForm.any_time_with_zero")}
                {/* {moment.utc(data.item_preference).format('08:00 AM')} */}
              </Fragment>
            ) : (
              <Fragment>
                <DisplayTime
                  isUTC={true}
                  displayWithDate={true}
                  dateTimeString={data.start_time}
                  key="drop_start_time"
                />
                -
                <DisplayTime
                  isUTC={true}
                  displayWithDate={false}
                  dateTimeString={data.end_time}
                  key="drop_end_time"
                />
              </Fragment>
            )}
          </span>
        ) : null}
      </>
    );
  };

  return (
    <div>
      {/* Quot num logo details */}
      <div className="Quote-logo">
        <div className="quote-address">
          <div style={{ color: "#66717B" }}>
            <div>
              <TableImageColumn record={logo} width={100} borderRadius={5} />
            </div>
            {wh_location_details?.l_address.address_line1},
            {wh_location_details?.l_address.city}
          </div>
        </div>
        <div className="quote-num">
          <div>
            <div className="label">Quote Number</div>
            <div className="value">
              {orders?.order_number ? `#${quote.quote_order_number}` : ""}
            </div>
          </div>
          <div>
            <div className="label">Quote Total</div>
            <div className="value" style={{ fontWeight: "bold" }}>
              $ {addonDetails?.quote_amount.toFixed(decimalPoints) || zeroValue}
            </div>
          </div>
        </div>
      </div>

      {/* Account */}
      <div className="quote-account">
        <div className="account-name">
          <div>Account</div>
          <div className="name">{quote?.account_name}</div>
        </div>

        <div className="quote-date">
          <div>
            <div className="key">Date</div>
            <div className="value">
              {moment.utc(quote?.quote_date).format(AppConfig.dateFormat)}
            </div>
          </div>
          <div>
            <div className="key">Expires</div>
            <div className="value">
              {moment.utc(quote?.expiry_date).format(AppConfig.dateFormat)}
            </div>
          </div>
        </div>
      </div>

      {/* Pickup and delivery address */}
      {/* <div className="pick-delivery-card">
        <div>
          <div className="pick">
            <PickupIconEstimate />
            &nbsp; Pickup Address :{" "}
            {pickup_location_details?.l_address.address_line1},{" "}
            {pickup_location_details?.l_address.city}
          </div>
          <div className="flex">
            <p>Date :</p>
            <p style={{ color: "black" }}>
              {!(quote?.type_of_order === "D") &&
                renderPickupDropTime("Pickup", pickTime)}
              {quote && !(quote.type_of_order === "D") ? 
                renderPickupDropTime("Pickup", pickTime) : 'NA'}
            </p>
            <p style={{ paddingLeft: "40px" }}>LOS:</p>
            <p style={{ color: "black", paddingLeft: "10px" }}>
              {pickup_location_details?.los_name}
            </p>
          </div>
        </div>
        <div>
          <div className="pick">
            <DeliveryIconEstimate />
            &nbsp; Delivery Address :{" "}
            {delivery_location_details?.l_address.address_line1},{" "}
            {delivery_location_details?.l_address.city}
          </div>
          <div className="flex gap-2">
            <p>Date :</p>
            <p style={{ color: "black" }}>
              {!(quote?.type_of_order === "R") &&
                renderPickupDropTime("Drop", dropTime)}
              {moment
                .utc(appointment?.end_datetime)
                .format(AppConfig.dateFormat)}
            </p>
            <p style={{ paddingLeft: "40px" }}>LOS: </p>
            <p style={{ color: "black" }}>
              {" "}
              {delivery_location_details?.los_name}
            </p>
          </div>
        </div>
      </div> */}
      {renderPickDropDate()}
      {/* Details section */}
      <div className="details-heading">
        <div
          style={{
            fontWeight: "bold",
            marginTop: "15px",
            color: "black",
            fontSize: "18px",
          }}
        >
          Details
        </div>
      </div>
      <div className="details-section" style={{ width: "100%" }}>
        {/* Left side - small heading */}
        <div
          className="details-left"
          style={{ width: "80%", marginRight: "30px", padding: "0px 10px" }}
        >
          {/* First section */}
          <div className="warehouse-section">
            <div>
              <div className="flex-row">
                <p>{I18n.t("general.warehouse")}</p>
                <p>{wh_location_details?.name}</p>
              </div>
              <div className="flex-row">
                <p>{I18n.t("general.Weight")}</p>
                <p>
                  {getFormattedWeight(
                    quote?.weight,
                    quote?.weight_in_kgs,
                    Number(orgRules.org_billing_rules.round_off_decimals)
                  )}
                </p>
              </div>
              <div className="flex-row">
                <p>Linehaul</p>
                <p>{addonDetails?.linehaul_charge || "Not Opted"}</p>
              </div>
              <div className="flex-row">
                <p>Intermediate Storange</p>
                <p>{quote?.wh_storage || "Not Required"}</p>
              </div>
              <div className="flex-row">
                <p>Target {I18n.t("general.warehouse")}</p>
                <p>
                  {quote?.target_warehouse_code
                    ? quote?.target_warehouse_name
                    : "NA"}
                </p>
              </div>
              <div className="flex-row">
                <p>Target Account</p>
                <p>
                  {quote?.target_account_code
                    ? quote?.target_account_name
                    : "NA"}
                </p>
              </div>
              <div className="flex-row">
                <p>Target {I18n.t('general.short_los')}</p>
                <p>
                  {quote?.target_level_of_service
                    ? quote?.target_los_name
                    : "NA"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - Table */}
        <div>
          <table
            // border="1px"
            cellpadding="5px"
            cellspacing="0px"
            width="100%"
            style={{ ...borderCollapseInherit }}
            className="charge-details-table"
          >
            <tbody>
              <tr>
                <td width="250px" className="table-heading alignLeft">
                  Charges
                </td>
                <td width="250px" className="table-heading alignRight">
                  Amount
                </td>
              </tr>
              <tr>
                <td className="tbody-item-body">
                  {quote?.type_of_order == "T"
                    ? "Pickup Transport"
                    : "Transportation"}
                </td>
                <td className="tbody-item-body alignRight">
                  {quote?.type_of_order == "T"
                    ? ` ${
                        "$" +
                          quoteCharges?.pickup_transportation_charge.toFixed(
                            decimalPoints
                          ) || zeroValue
                      }`
                    : `${
                        "$" +
                          quoteCharges?.transportation_charge.toFixed(
                            decimalPoints
                          ) || zeroValue
                      }`}
                </td>
              </tr>
              {quote?.type_of_order == "T" && (
                <tr>
                  <td className="tbody-item-body">Delivery Transport</td>
                  <td className="tbody-item-body alignRight">
                    {"$" +
                      quoteCharges?.delivery_transportation_charge.toFixed(
                        decimalPoints
                      ) || zeroValue}
                  </td>
                </tr>
              )}
              {quote?.type_of_order == "T" && (
                <tr>
                  <td className="tbody-item-body">Pickup Fuel</td>
                  <td className="tbody-item-body alignRight">
                    {"$" +
                      quoteCharges?.pickup_fuel_surcharge.toFixed(
                        decimalPoints
                      ) || zeroValue}
                  </td>
                </tr>
              )}
              {quote?.type_of_order == "T" && (
                <tr>
                  <td className="tbody-item-body">Delivery Fuel</td>
                  <td className="tbody-item-body alignRight">
                    {"$" +
                      quoteCharges?.delivery_fuel_surcharge.toFixed(
                        decimalPoints
                      ) || zeroValue}
                  </td>
                </tr>
              )}
              {quote?.type_of_order !== "T" && (
                <tr>
                  <td className="tbody-item-body">Fuel Charges</td>
                  <td className="tbody-item-body alignRight">
                    {"$" +
                      quoteCharges?.fuel_surcharge.toFixed(
                        decimalPoints
                      ) || zeroValue}
                  </td>
                </tr>
              )}
              <tr>
                <td className="tbody-item-body">Special Charges</td>
                <td className="tbody-item-body alignRight">
                  {"$" +
                    quoteCharges?.additional_charges.toFixed(
                      decimalPoints
                    ) || zeroValue}
                </td>
              </tr>
              {quoteCharges?.ori_accessorial_charges &&
                quoteCharges?.ori_accessorial_charges.map((val) => (
                  <tr key={val?.id}>
                    <td className="tbody-item-body">{val?.accessorial_name}</td>
                    <td className="tbody-item-body alignRight">
                      {"$" + val?.accessorial_charge.toFixed(decimalPoints) ||
                        zeroValue}
                    </td>
                  </tr>
                ))}
              {addonDetails &&
                addonDetails?.add_on_details?.map((item) => {
                  return (
                    <tr key={item?.id}>
                      <td className="tbody-item-body">{item?.add_on_name}</td>
                      <td className="tbody-item-body alignRight">
                        {"$" + item?.add_on_value.toFixed(decimalPoints) ||
                          zeroValue}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {/* <table width="100%" style={{ ...marginTop20 }}>
            <tbody>
              <tr>
                <td width="50.5%" style={{ ...marginTop40 }} />
                <td width="49.5%">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td
                          width="60%"
                          style={{ ...alignRight, ...totalItems, ...textBold , color:"black", fontSize:"18px" }}
                        >
                          Sub Total
                        </td>
                        <td
                          width="58%"
                          style={{
                            ...alignRight,
                            ...totalItems,
                            ...textBold,
                            color:"black",
                            fontSize:"18px"
                          }}
                        >
                          $12300{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table> */}
          <div className="total">
            <p>Total</p>
            <p>
              {"$" + addonDetails?.quote_amount.toFixed(decimalPoints) ||
                zeroValue}
            </p>
          </div>
        </div>
      </div>

      {/* Notes and Disclaimer */}
      <div className="notes-section">
        <div style={{ fontWeight: "bold", color: "black" }}>Notes</div>
        <p>{quote?.notes}</p>
        <p>
          <strong>Disclaimer</strong>
        </p>
        <p>{quote?.quote_disclaimer}</p>
      </div>
    </div>
  );
}

export default QuoteOrderDetails;
